import { useEffect, useState } from 'react'
import close from '../../../assets/icons/close.svg';
import search from '../../../assets/icons/iconamoon_search-light.svg';
import imagePlaceholder from '../../../assets/Images/image 17.png';
import add from '../../../assets/icons/add.svg';
import deletered from '../../../assets/icons/deletered.svg';
import previous from '../../../assets/icons/previous.svg';
import next from '../../../assets/icons/icon.svg';
import savedraft from '../../../assets/icons/savedraft.svg';
import Select from 'react-select';
import { components } from 'react-select';
import { getData } from '../../../API/GlobalApi';


export const OfficialDetails = ({
  onClose,
  currentStep,
  isEditMode,
  setCurrentStep,
  handlePrev,
  handleNext,
  steps,
  handleOfficialChange,
  handleBankChange,
  bankDetails,
  setBankDetails,
  officialDetails,
  setOfficialDetails,
  getofficialdetailmaster,

  departmentfromorg,
  desigfromorg, handleSubmitOfficialDetails,
  emoployeeId,
  getorgdata,
  setorgdata, orgdata,
  isLoadingFormDetails,
  setdepartmentfromorg, setdesigfromorg, handlePermissionChange, newPermissions, setNewPermissions,
  assignedCourses, setAssignedCourses, allCourses
}) => {

  useEffect(() => {
    getorgdata();

  }, [])


  const bankOptions = getofficialdetailmaster?.banks?.map(bank => ({
    value: bank.id,
    label: bank.name
  })) || [];

  const courseOptions = (allCourses || []).map(course => ({
    value: course.id,
    label: course.name
  }));

  const selectAllOption = { value: '__select_all__', label: 'Select All' };
  const courseOptionsWithAll = [selectAllOption, ...courseOptions];

  const handleCourseChange = (selected) => {
    if (!selected) return setAssignedCourses([]);
    if (selected.some(o => o.value === '__select_all__')) {
      if (assignedCourses.length === courseOptions.length) {
        setAssignedCourses([]);
      } else {
        setAssignedCourses(courseOptions);
      }
    } else {
      setAssignedCourses(selected);
    }
  };

  const reactSelectStyles = {
    control: (base) => ({ ...base, minHeight: '50px', height: '50px' }),
    valueContainer: (base) => ({ ...base, height: '50px', padding: '0 6px', fontSize: '14px' }),
    option: (base, state) => ({
      ...base,
      fontSize: '14px',
      backgroundColor: state.isSelected ? '#ddd' : state.isFocused ? '#f0f0f0' : 'white',
      color: 'black',
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    multiValue: (base) => ({ ...base, backgroundColor: '#EDE9FB', borderRadius: '4px' }),
    multiValueLabel: (base) => ({ ...base, color: '#7F56DA', fontSize: '13px' }),
    multiValueRemove: (base) => ({ ...base, color: '#7F56DA', ':hover': { backgroundColor: '#7F56DA', color: 'white' } }),
  };

  return (
    <>
      {isLoadingFormDetails ? (
        <div className="text-center" style={{
          height: "77vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          color: "#7F56DA",
        }}>
          <div
            className="spinner-border"
            role="status"
            style={{ color: '#7F56DA', width: '3rem', height: '3rem' }}
          />
          <p className="mt-2">Loading Employee details...</p>
        </div>

      ) : (
        <>

          <div className="col-md-10" style={{ height: "77vh", overflowY: 'scroll' }}>
            <div style={{ position: 'sticky', top: 0, background: "#fff", paddingBottom: "25px" }}>
              <div className="modal-header-content" style={{ display: 'flex', justifyContent: 'space-between' }}>
                <h2 className='text-primary'>Official Details</h2>
              </div>
            </div>

            <div className="row" >
              <div className="col-md-3">
                <label className='form-labell'>Institution<span className='astrisk'>*</span></label>
                <select className='fm-modal form-control form-select' name="organization" value={officialDetails?.organization} onChange={handleOfficialChange}>
                  <option value=''>Select Institution</option>
                  {orgdata && orgdata?.map((val, ind) => (
                    <option key={ind} value={val.id}>{val.name}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-3">
                <label className='form-labell'>Department<span className='astrisk'>*</span></label>
                <select className='fm-modal form-control form-select' name="department" value={officialDetails?.department} onChange={handleOfficialChange}>
                  <option value=''>Select Department</option>
                  {departmentfromorg && departmentfromorg?.map((val, ind) => (
                    <option key={ind} value={val.id}>{val.name}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-3">
                <label className='form-labell'>Designation<span className='astrisk'>*</span></label>
                <select className='fm-modal form-control form-select' name="designation" value={officialDetails?.designation} onChange={handleOfficialChange}>
                  <option value=''>Select Designation</option>
                  {desigfromorg && desigfromorg?.map((val, ind) => (
                    <option key={ind} value={val.id}>{val.name}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-3">
                <label className='form-labell'>Report To</label>
                <select className='fm-modal form-control form-select' name="reportTo" value={officialDetails?.reportTo} onChange={handleOfficialChange}>
                  <option value=''>Select Report To</option>
                  {getofficialdetailmaster && getofficialdetailmaster.employees.map((val, ind) => (
                    <option key={ind} value={val.employee_id}>{val.name}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="row" >
              <div className="col-md-3">
                <label className='form-labell'>Employee Code</label>
                <input type="text" className='fm-modal form-control' name="uniquecode" value={officialDetails.uniquecode} onChange={handleOfficialChange} placeholder="Enter Employee Code" />
              </div>
              <div className="col-md-3">
                <label className='form-labell'>Employee Type</label>
                <select className='fm-modal form-control form-select' name="employmentType" value={officialDetails.employmentType} onChange={handleOfficialChange}>
                  <option value="">Select</option>
                  {getofficialdetailmaster && getofficialdetailmaster.employment_type?.map((val, ind) => (
                    <option key={ind} value={val}>{val}</option>
                  ))}
                </select>
              </div>

              <div className="col-md-3">
                <label className='form-labell'>Working Shift</label>
                <select className='fm-modal form-control form-select' name="workingShift" value={officialDetails.workingShift} onChange={handleOfficialChange}>
                  <option value="">Select</option>
                  {getofficialdetailmaster && getofficialdetailmaster.working_shift?.map((val, ind) => (
                    <option key={ind} value={val}>{val}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-3">
                <label className='form-labell'>Date of Joining</label>
                <input type="date" className='fm-modal form-control' name="dateOfJoining" value={officialDetails.dateOfJoining} onChange={handleOfficialChange} />
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className='linehr'></div>
              </div>
            </div>

            <div className="row">
              <div>
                <h4 className='fm-pr-hd'>BANK DETAILS</h4>
              </div>

              <div className="col-md-3">
                <label className='form-labell'>
                  Bank Name
                </label>
                <Select
                  className='react-select-container'
                  classNamePrefix='react-select'
                  options={bankOptions}
                  value={bankOptions.find(option => option.value === bankDetails.bank_id) || null}
                  onChange={(selectedOption) => {
                    setBankDetails(prev => ({
                      ...prev,
                      bank_id: selectedOption ? selectedOption.value : ''
                    }));
                  }}
                  placeholder="Select Bank"
                  isClearable
                  menuPortalTarget={document.body}
                  styles={reactSelectStyles}
                />
              </div>
              <div className="col-md-3">
                <label className='form-labell'>Account Holder Name </label>
                <input type="text" className='fm-modal form-control' name="accountHolderName" value={bankDetails.accountHolderName} onChange={handleBankChange} placeholder="Enter Account Holder Name" />
              </div>
              <div className="col-md-3">
                <label className='form-labell'>Bank Account Number</label>
                <input type="text" className='fm-modal form-control' name="accountNumber" value={bankDetails.accountNumber} onChange={handleBankChange} placeholder="Enter Account Number" />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className='linehr'></div>
              </div>
            </div>

            <div>
              <h4 className='fm-pr-hd'>ASSIGNED COURSES</h4>
            </div>

            <div className="row mb-3">
              <div className="col-md-12">
                <label className='form-labell'>Assigned Courss</label>
                <Select
                  className='react-select-container'
                  classNamePrefix='react-select'
                  isMulti
                  options={courseOptionsWithAll}
                  value={assignedCourses}
                  onChange={handleCourseChange}
                  placeholder="Select Courses..."
                  isClearable
                  menuPortalTarget={document.body}
                  styles={{
                    ...reactSelectStyles,
                    control: (base) => ({ ...base, minHeight: '50px' }),
                    valueContainer: (base) => ({ ...base, padding: '4px 6px', fontSize: '14px', flexWrap: 'wrap', height: 'auto' }),
                    option: (base, state) => ({
                      ...base,
                      fontSize: '14px',
                      fontWeight: state.data.value === '__select_all__' ? '600' : 'normal',
                      backgroundColor: state.isSelected ? '#ddd' : state.isFocused ? '#f0f0f0' : 'white',
                      color: state.data.value === '__select_all__' ? '#7F56DA' : 'black',
                    }),
                  }}
                />
              </div>
            </div>

            <div>
              <h4 className='fm-pr-hd'>PERMISSIONS</h4>
            </div>

            <div className="row">
              {getofficialdetailmaster?.permissions?.map((permission) => (
                <div className="col-md-4 mb-2" key={permission.id}>
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={`permission-${permission.id}`}
                      checked={newPermissions.some(p => p.id === permission.id)}
                      onChange={(e) => handlePermissionChange(e, permission)}
                    />
                    <label className="form-check-label" htmlFor={`permission-${permission.id}`}>
                      {permission.name}
                    </label>
                  </div>
                </div>
              ))}
            </div>


          </div>


          <div className="form-actions" style={{ position: 'sticky', background: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: "flex", gap: '20px' }}>


              <button type="button" onClick={handlePrev} style={{ display: 'flex', alignItems: 'center', gap: "10px" }} disabled={currentStep === 0}><img src={previous}></img>Previous</button>
              {/* <p style={{ cursor: 'pointer', display: 'flex', gap: '5px', alignItems: 'center', color: 'red', margin: 0 }}><img src={savedraft}></img>Save to Draft</p> */}
            </div>
            <div>
              <div style={{ display: "flex", gap: "10px" }}>

                <button
                  type="button"
                  style={{ display: 'flex', alignItems: 'center', gap: "10px", }}
                  onClick={async () => {
                    const success = await handleSubmitOfficialDetails('save_and_close');

                    if (success) {
                      onClose(); // close modal after successful save
                    }
                  }}
                >
                  Save & Close
                </button>

                <button type="submit" style={{ display: 'flex', alignItems: 'center', gap: "10px" }} onClick={async () => {
                  let fn = await handleSubmitOfficialDetails('save_and_next');
                  if (fn) {
                    handleNext();
                  }
                  // handleNext();
                }}
                  disabled={currentStep === steps.length - 1}>Save & Next<img src={next}></img></button>
              </div>
            </div>
          </div>
        </>
      )
      }
    </>
  );
};
